import { No, StrongNo, StrongYes, Yes } from '@/assets/icons/scorecard';

import { cloneDeep } from 'lodash-es';
let ratingOptionsConfig = [
  {
    value: 'strong_yes',
    label: 'Strong yes',
    icon: StrongYes,
    isSelected: false,
    selectedColor: 'success-300',
    bgColor: 'pastel-2-light',
  },
  {
    value: 'yes',
    label: 'Yes',
    icon: Yes,
    isSelected: false,
    selectedColor: 'success-300',
    bgColor: 'pastel-2-light',
  },
  {
    value: 'no',
    label: 'No',
    icon: No,
    isSelected: false,
    selectedColor: 'error-300',
    bgColor: 'pastel-1-light',
  },
  {
    value: 'strong_no',
    label: 'Strong no',
    icon: StrongNo,
    isSelected: false,
    selectedColor: 'error-300',
    bgColor: 'pastel-1-light',
  },
];

let ratingOptions = cloneDeep(ratingOptionsConfig);

let scorecardColors = {
  strong_yes: '#079455',
  yes: '#079455',
  no: '#B50808',
  strong_no: '#B50808',
};

let getSelectionRatingStyle = (selectedRating) => {
  let scorecardStyles = {};
  if (selectedRating?.value) {
    scorecardStyles = {
      color: scorecardColors?.[selectedRating?.value] || '#6D659D',
      className: `checked_${selectedRating?.value}`,
    };

    if (selectedRating?.value === 'strong_yes') {
      scorecardStyles['w'] = '24px';
      scorecardStyles['h'] = '24px';
    }
  }
  return scorecardStyles;
};
export {
  ratingOptions,
  scorecardColors,
  getSelectionRatingStyle,
  ratingOptionsConfig,
};
